"use strict";

;
(function (SidebarNav) {
  var sidebarDisplay = function sidebarDisplay() {
    if (!document.querySelector('.sidebar-nav__container')) return;
    var nearEndOfPage = checkPageOffset();
    var stickyNav = document.querySelector('.site-header-sticky');
    var stickyNavHeight = stickyNav ? stickyNav.offsetHeight : 0;
    var container = document.querySelector('.sidebar-nav__container');
    var staticAboutNav = document.querySelector('.static-about-nav');
    var staticHeight = staticAboutNav ? staticAboutNav.offsetHeight : 0;
    var containerTop = container.getBoundingClientRect().top + window.scrollY;
    var atBreakpoint = containerTop + staticHeight - window.pageYOffset <= stickyNavHeight;
    if (nearEndOfPage) {
      hideFixedBar();
    } else {
      atBreakpoint ? showFixedBar() : hideFixedBar();
    }
  };
  var showCurrentSection = function showCurrentSection() {
    var blockContents = document.querySelectorAll('.block-content');
    if (!blockContents.length) return;
    var staticAboutNav = document.querySelector('.static-about-nav');
    var staticLeft = staticAboutNav ? staticAboutNav.getBoundingClientRect().left + window.scrollX : 0;
    var number = 1;
    var offsets = [];
    var fixedAboutNav = document.querySelector('.fixed-about-nav');
    if (fixedAboutNav) fixedAboutNav.style.left = staticLeft + 'px';
    blockContents.forEach(function (block) {
      var top = block.getBoundingClientRect().top + window.scrollY - 150;
      offsets.push(top);
      if (window.pageYOffset > top) {
        number = parseInt(block.dataset.number, 10);
      }
    });
    var titleBlock = blockContents[number - 1];
    var title = titleBlock ? titleBlock.dataset.title : '';
    document.querySelectorAll('.current-sidebar-section .section-number').forEach(function (el) {
      el.textContent = number;
    });
    document.querySelectorAll('.current-sidebar-section .section-heading').forEach(function (el) {
      el.textContent = title;
    });
    offsets.forEach(function (offset) {
      if (offset === window.pageYOffset && offset !== offsets[0]) {
        number += 1;
      }
    });
    document.querySelectorAll('.all-sections-container .page-section').forEach(function (el) {
      el.classList.remove('active');
    });
    document.querySelectorAll(".all-sections-container .page-section-".concat(number)).forEach(function (el) {
      el.classList.add('active');
    });
  };
  var showFixedBar = function showFixedBar() {
    var fixedBar = document.querySelector('.fixed-about-nav');
    if (!fixedBar || fixedBar.classList.contains('active')) return;
    var stickyNav = document.querySelector('.site-header-sticky');
    var height = stickyNav ? stickyNav.offsetHeight : 0;
    fixedBar.classList.add('active');
    fixedBar.style.top = height + 'px';
  };
  var hideFixedBar = function hideFixedBar() {
    var fixedBar = document.querySelector('.fixed-about-nav');
    if (fixedBar) fixedBar.classList.remove('active');
  };
  var closeDropdown = function closeDropdown() {
    document.querySelectorAll('.all-sections-container').forEach(function (el) {
      return el.classList.remove('open');
    });
    document.querySelectorAll('.current-sidebar-section .icon-right-arrow').forEach(function (el) {
      el.classList.remove('active');
    });
  };
  var checkPageOffset = function checkPageOffset() {
    var firstElement = document.querySelector('.hero');
    var lastElement = document.querySelector('.related-content') || document.querySelector('.similar-posts-section') || document.querySelector('.related-content-section') || document.querySelector('#shopify-section-footer');
    if (!firstElement || !lastElement) return false;

    // getBoundingClientRect().top is equivalent to offset().top - pageYOffset
    var nearHeader = firstElement.getBoundingClientRect().top >= -800 && window.innerWidth >= 1024;
    var nearFooter = lastElement.getBoundingClientRect().top <= 750 && window.innerWidth >= 1024;
    return nearFooter || nearHeader;
  };
  var displayActiveSection = function displayActiveSection() {
    var reference = window.location.href.replace(/(.*\/blogs\/)|(.*\/pages\/)/g, '');
    document.querySelectorAll('.static-about-nav .section-content a').forEach(function (link) {
      var url = link.getAttribute('href').replace(/(.*\/blogs\/)|(.*\/pages\/)/g, '');
      var number = link.dataset.number;
      var titleEl = document.querySelector(".all-sections-container .page-section-".concat(number));
      var title = titleEl ? titleEl.dataset.title : '';
      if (reference === url) {
        document.querySelectorAll('.all-sections-container .page-section').forEach(function (el) {
          el.classList.remove('active');
        });
        var activeEl = document.querySelector(".all-sections-container .page-section-".concat(number));
        if (activeEl) activeEl.classList.add('active');
        document.querySelectorAll('.current-sidebar-section .section-number').forEach(function (el) {
          el.textContent = number;
        });
        document.querySelectorAll('.current-sidebar-section .section-heading').forEach(function (el) {
          el.textContent = title;
        });
      }
    });
  };
  var goToSection = function goToSection(number) {
    var section = document.querySelector(".block-content[data-number=\"".concat(number, "\"]"));
    if (!section) return;
    var sectionTop = section.getBoundingClientRect().top + window.scrollY;
    var offset = window.innerWidth <= 1023 ? sectionTop - 100 : sectionTop + 30;
    window.scrollTo({
      top: offset
    });
  };
  var eventHandlers = function eventHandlers(page) {
    window.addEventListener('scroll', function () {
      if (document.querySelector('.sidebar-nav__container')) {
        showCurrentSection();
      }
    });
    document.querySelectorAll('.current-sidebar-section').forEach(function (el) {
      el.addEventListener('click', function () {
        var nav = this.closest('.sidebar__nav');
        var container = nav ? nav.querySelector('.all-sections-container') : null;
        var arrow = nav ? nav.querySelector('.icon-right-arrow') : null;
        if (container) container.classList.toggle('open');
        if (arrow) arrow.classList.toggle('active');
      });
    });
    document.querySelectorAll('.all-sections-container .page-section').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var number = this.dataset.topic;
        if (page !== 'about') {
          window.location.href = '/pages/about?' + number;
        }
        goToSection(number);
        if (window.innerWidth <= 1023) {
          closeDropdown();
        }
      });
    });
  };
  SidebarNav.init = function (page) {
    eventHandlers(page);
    showCurrentSection();
    if (page === 'about') {
      setInterval(sidebarDisplay, 100);
    }
    if (page !== 'about') {
      displayActiveSection();
    } else {
      var hasParams = /(\?)|([0-9])/g;
      if (window.location.href.match(hasParams)) {
        var parts = window.location.href.split('?');
        var number = parts[1];
        goToSection(number);
      }
    }
  };
})(window.SidebarNav = window.SidebarNav || {});